import Layout from "../components/Layout";
import { ReviewList } from "../components/Entries";
import { reviews } from "../content/writing";
import styles from "../styles/Site.module.css";

const Reviews = () => {
    return (
        <Layout>
            <h1 className={styles.pageTitle}>Book Reviews</h1>
            <p className={styles.intro}>
                Notes on books I've read.
            </p>
            <ReviewList items={reviews} />
        </Layout>
    );
};

export default Reviews;
